import { render, staticRenderFns } from "./CaseGrassrootsOrganizationalEducation.vue?vue&type=template&id=1712bb67"
import script from "./CaseGrassrootsOrganizationalEducation.vue?vue&type=script&lang=js"
export * from "./CaseGrassrootsOrganizationalEducation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports